// API base URL resolution, in order:
//   1. the runtime `__APP__.API_URL` the container entrypoint injects into
//      index.html at start (production and staging: one image, any environment)
//   2. VITE_API_URL inlined at build time (local builds, the release gate)
//   3. relative, so requests go through the Vite dev-server proxy → backend:8000
// The runtime value comes first on purpose: the deployed image bakes no URL, so
// the same digest that passed staging is what production runs. If the
// placeholder is ever left unsubstituted (the literal "__RUNTIME_API_URL__",
// which is what the Vite dev server serves, or the older "%VITE_API_URL%"), it
// is ignored rather than turned into a malformed URL.
export function isUnsubstitutedPlaceholder(value: string): boolean {
  return value.includes('%') || value.includes('__RUNTIME_API_URL__')
}
export function resolveApiUrl(runtimeApiUrl: unknown, buildApiUrl: string | undefined): string {
  const runtime =
    typeof runtimeApiUrl === 'string' && runtimeApiUrl && !isUnsubstitutedPlaceholder(runtimeApiUrl) ? runtimeApiUrl : ''
  return runtime || buildApiUrl || ''
}

/**
 * The API base for EVERY caller, resolved once from the page. Modules must
 * never read import.meta.env.VITE_API_URL themselves: a deployed image bakes
 * no URL (the container injects it at start), so a direct read falls back
 * to a localhost default and the browser posts to the user's own machine,
 * which is exactly how the first staging login failed.
 */
export function getApiBaseUrl(): string {
  const runtime = typeof window !== 'undefined' ? (window as any).__APP__?.API_URL : undefined
  return resolveApiUrl(runtime, import.meta.env.VITE_API_URL)
}
